import { Container, TextField,Grid, Button, Typography, CircularProgress, Alert} from "@mui/material"
import logoHeader from "../../images/logo_mabe_header.svg"
import { loginStyles } from "./LoginPageStyles"
import { GeneralStyles } from "../../styles/GeneralStyles"
import { useEffect, useState } from "react"
import { useAuth } from "../../components/AuthProvider"
import { useNavigate } from "react-router-dom"
import { validateToken } from "../../services/AuthService"
import 'react-toastify/dist/ReactToastify.css';

const LoginPage = () => {
    const[username, setUsername] = useState("")
    const [password, setPassword] = useState("")
    const {loginAction, loadingSuccess, message} = useAuth()
    const token = localStorage.getItem("site")
    const navigate = useNavigate()
    
    const handleLogin = async (e) => {
        e.preventDefault()
        
        const requestBody = {
            grantType: "password",
            username: username,
            password: password,
            customerAdditionalData: {
                customerSecret: process.env.REACT_APP_API_CUSTOMER_SECRET_LOGIN
            },
        };
        loginAction(requestBody) 
    }

    useEffect(()=>{
        validateToken(token)
            .then((response) => {
                if (response.status === 200) {
                    navigate("/dashboard/products")
                }
            }).catch((err)=>{
            })
    },[])

    return (
        <Container maxWidth="100%" disableGutters sx={loginStyles.rootContainer}>
            <Container maxWidth="100%" sx={loginStyles.headerContainer}>
                <img src={logoHeader} width={"250px"}  alt="Mabe"/>
            </Container>
            <Container maxWidth="xs" disableGutters>
                <form onSubmit={handleLogin}>
                    <Grid container spacing={2} direction={"column"}>
                        <Grid item xs={12}>
                            <Typography variant="h3" color="primary" sx={GeneralStyles.textCenter}>
                                {"Inventory".toUpperCase()}
                            </Typography>    
                        </Grid>
                        <Grid item xs={12}>
                            <TextField id="username" label="Username" variant="outlined" fullWidth
                                onChange={(e) => setUsername(e.target.value)} value={username}/>    
                        </Grid>
                        <Grid item xs={12}>
                            <TextField id="password" label="Password" variant="outlined" fullWidth type="password"
                                onChange={(e) => setPassword(e.target.value)} value={password}/>
                        </Grid>
                        <Grid item xs={12}>
                            <Button type="submit" fullWidth variant="contained" color="primary" disabled={loadingSuccess}>
                                {loadingSuccess ? <CircularProgress size={24}/> : 'Login'}
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </Container>
            <footer>
                <Typography variant="body2" sx={{textAlign: "center", display: "flex", flexDirection: "column"}}>
                    <a target="_blank" href={process.env.REACT_APP_URL_TERMS_AND_CONDITIONS} rel="noopener noreferrer">
                        Terms and Conditions
                    </a>
                    &copy; {new Date().getFullYear()} ALL RIGHTS RESERVED FOR MABE CANADA
                </Typography>
            </footer>    
        </Container>
    )
}

export default LoginPage